(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-product-details"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('art-detail-tabs')) customElements.define('art-detail-tabs',class extends HTMLElement {
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const o={signal:this.abort.signal};
      this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll(':scope > details')];this.active=0;
      this.media=matchMedia('(min-width:768px)');this.setAttribute('data-enhanced','');this.querySelector('[role=tablist]').hidden=false;
      this.tabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>{this.active=i;this.update();},o);
        tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();this.active=e.key==='Home'?0:e.key==='End'?this.tabs.length-1:(i+(e.key==='ArrowLeft'?-1:1)+this.tabs.length)%this.tabs.length;this.update();this.tabs[this.active].focus();},o);
      });
      this.media.addEventListener('change',()=>this.update(),o);this.update();
    }
    update(){this.panels.forEach((panel,i)=>{panel.hidden=this.media.matches&&i!==this.active;panel.open=this.media.matches||i===this.active;if(this.media.matches){panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',this.tabs[i].id);}else{panel.removeAttribute('role');panel.removeAttribute('aria-labelledby');}this.tabs[i].setAttribute('aria-selected',String(i===this.active));this.tabs[i].tabIndex=i===this.active?0:-1;});}
    disconnectedCallback(){this.abort?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-product-editorial"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('art-artist-tabs'))customElements.define('art-artist-tabs',class extends HTMLElement{
    connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.tabs=[...this.querySelectorAll('[role=tab]')];this.tabs.forEach((tab,i)=>{tab.tabIndex=i===0?0:-1;tab.addEventListener('click',()=>this.select(tab),{signal:this.abort.signal});tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const j=e.key==='Home'?0:e.key==='End'?this.tabs.length-1:(i+(e.key==='ArrowLeft'?-1:1)+this.tabs.length)%this.tabs.length;this.select(this.tabs[j]);this.tabs[j].focus();},{signal:this.abort.signal});});}
    select(tab){this.tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;const panel=this.querySelector('#'+CSS.escape(t.getAttribute('aria-controls')));if(panel)panel.hidden=!active;});}
    disconnectedCallback(){this.abort?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('artist-collection-tabs'))customElements.define('artist-collection-tabs',class extends HTMLElement{
    connectedCallback(){this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};this.panels=[...this.querySelectorAll(':scope > [data-artist-panel]')];const nav=this.querySelector('[role=tablist]');nav.replaceChildren();this.panels.forEach((panel,i)=>{const button=document.createElement('button');button.type='button';button.id=panel.id+'-tab';button.textContent=panel.dataset.title;button.setAttribute('role','tab');button.setAttribute('aria-controls',panel.id);panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);button.addEventListener('click',()=>this.select(i),opts);button.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?this.panels.length-1:(i+(e.key==='ArrowRight'?1:-1)+this.panels.length)%this.panels.length;this.select(next);nav.children[next].focus();},opts);nav.append(button);});nav.hidden=this.panels.length<2;this.tabs=[...nav.children];this.select(0);this.querySelectorAll('[data-bio-toggle]').forEach(button=>button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')==='true';document.getElementById(button.getAttribute('aria-controls')).classList.toggle('is-collapsed',expanded);button.setAttribute('aria-expanded',String(!expanded));button.querySelector('span').textContent=expanded?button.dataset.more:button.dataset.less;},opts));this.addEventListener('shopify:block:select',e=>{const i=this.panels.findIndex(panel=>panel===e.target||panel.contains(e.target));if(i>=0)this.select(i);},opts);}
    select(index){this.panels.forEach((panel,i)=>{panel.hidden=i!==index;this.tabs[i].setAttribute('aria-selected',String(i===index));this.tabs[i].tabIndex=i===index?0:-1;if(i===index)requestAnimationFrame(()=>panel.querySelectorAll('slider-element').forEach(slider=>{slider.init?.();slider.update?.();}));});}
    disconnectedCallback(){this.abort?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('tabs-element').then(() => {
    if (customElements.get('gallery-collection-tabs')) return;
    customElements.define('gallery-collection-tabs', class extends customElements.get('tabs-element') {
      connectedCallback() {
        super.connectedCallback();
        this.on(this, 'keydown', event => {
          const button = event.target.closest('[role="tab"]');
          if (!button || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          let index = this.buttons.indexOf(button);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.buttons.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? direction : -direction) + this.buttons.length) % this.buttons.length;
          this.selectedIndex = index;
        });
      }
      transition(fromPanel, toPanel) {
        this.buttons.forEach(button => {
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) panel.hidden = panel !== toPanel;
          button.setAttribute('aria-selected', String(panel === toPanel));
        });
        if (!toPanel) return;
        const slider = toPanel.querySelector('slider-element');
        slider?.reset?.();
        slider?.updateButtons?.();
        const motion = toPanel.querySelector('motion-list');
        if (motion?.initialized) motion.load();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-tabs-accordion"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('pdp-tabs-accordion'))customElements.define('pdp-tabs-accordion',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
      this.items=[...this.querySelectorAll(':scope > .pdp-details__item')];if(!this.items.length)return;
      const nav=this.querySelector('[role=tablist]');nav.replaceChildren();
      this.items.forEach(item=>{const panel=item.querySelector('.pdp-details__panel'),tab=document.createElement('button');tab.type='button';tab.className='pdp-details__tab heading';tab.setAttribute('role','tab');tab.id=panel.id+'-tab';tab.setAttribute('aria-controls',panel.id);tab.textContent=item.querySelector('summary>span').textContent;nav.append(tab);});
      this.tabs=[...nav.children];
      // Choose once on load from the product's published Loox count; allow normal tab switching afterwards.
      const labels=this.tabs.map(tab=>tab.textContent.trim().toLowerCase());
      const aboutIndex=labels.indexOf('about the artwork');
      const reviewIndex=labels.findIndex(label=>label==='review'||label==='reviews');
      this.active=Number(this.dataset.reviewCount)>0&&reviewIndex>=0?reviewIndex:Math.max(aboutIndex,0);
      this.mobileActive=this.active;
      this.media=matchMedia('(min-width:769px)');this.setAttribute('data-enhanced','');this.querySelector('[role=tablist]').hidden=false;
      this.tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>this.select(i),options);tab.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const direction=getComputedStyle(this).direction==='rtl'?-1:1;let index=event.key==='Home'?0:event.key==='End'?this.tabs.length-1:(i+(event.key==='ArrowRight'?direction:-direction)+this.tabs.length)%this.tabs.length;this.select(index);this.tabs[index].focus();},options);});
      this.items.forEach((item,i)=>item.querySelector('summary').addEventListener('click',event=>{if(this.media.matches)return;event.preventDefault();this.mobileActive=this.mobileActive===i?-1:i;this.active=i;this.update();},options));
      this.media.addEventListener('change',()=>this.update(),options);
      this.addEventListener('shopify:block:select',event=>{const target=event.target.closest('[data-block-id]');const i=this.items.findIndex(item=>item===target||item.contains(target));if(i>=0){this.mobileActive=i;this.select(i);}},options);this.update();
    }
    select(i){this.active=i;this.mobileActive=i;this.update();}
    update(){this.items.forEach((item,i)=>{const selected=this.media.matches?i===this.active:i===this.mobileActive;item.hidden=this.media.matches&&!selected;item.open=selected;const panel=item.querySelector('.pdp-details__panel');if(this.media.matches){panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',this.tabs[i].id);}else{panel.removeAttribute('role');panel.removeAttribute('aria-labelledby');}this.tabs[i].setAttribute('aria-selected',String(i===this.active));this.tabs[i].tabIndex=i===this.active?0:-1;});}
    disconnectedCallback(){this.controller?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-room"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-by-room')) {
    customElements.define('shop-by-room', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.panels = [...this.querySelectorAll('[data-room-panel]')];
        this.track = this.querySelector('.shop-by-room__track');
        this.controls = [...this.querySelectorAll('[data-room-index]')];
        this.activeIndex = Number(this.dataset.initialIndex) || 0;
        this.track.style.transition = 'none';
        this.select(this.activeIndex, false);
        this.track.getBoundingClientRect();
        this.track.style.removeProperty('transition');
        this.initCarousel();
        document.addEventListener('DOMContentLoaded', () => this.initCarousel(), options);
        document.addEventListener('page:loaded', () => this.initCarousel(), options);
        window.addEventListener('load', () => this.initCarousel(), options);
        this.addEventListener('click', (event) => {
          const control = event.target.closest('[data-room-index]');
          if (control) this.select(Number(control.dataset.roomIndex));
        }, options);
        this.querySelectorAll('.shop-by-room__room').forEach((control) => {
          control.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            this.select(Number(control.dataset.roomIndex));
          }, options);
        });
        this.addEventListener('keydown', (event) => {
          const control = event.target.closest('[data-room-index]');
          if (!control || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = Number(control.dataset.roomIndex);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.panels.length - 1;
          else index += ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
          this.select(index);
          const selector = control.classList.contains('shop-by-room__dot') ? '.shop-by-room__dot' : '.shop-by-room__room';
          this.querySelectorAll(selector)[(index + this.panels.length) % this.panels.length]?.focus();
        }, options);
        const media = this.querySelector('.shop-by-room__media');
        this.imageObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.querySelectorAll('.shop-by-room__image').forEach((image) => {
            if (image.tagName !== 'IMG') return;
            image.loading = 'eager';
            image.decode().catch(() => {});
          });
          this.imageObserver.disconnect();
        }, { rootMargin: '200px' });
        this.imageObserver.observe(media);
        media.addEventListener('touchstart', (event) => {
          this.touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { ...options, passive: true });
        media.addEventListener('touchend', (event) => {
          if (!this.touchStart) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.select(this.activeIndex + (dx < 0 ? 1 : -1));
        }, { ...options, passive: true });
        media.addEventListener('touchcancel', () => { this.touchStart = null; }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, options);
      }
      initCarousel() {
        if (!this.isConnected || this.carousel || !window.Flickity) return;
        this.track.style.removeProperty('transform');
        this.carousel = new window.Flickity(this.track, {
          accessibility: false,
          draggable: false,
          pageDots: false,
          prevNextButtons: false,
          setGallerySize: false,
          wrapAround: true,
          rightToLeft: Boolean(window.theme?.config?.rtl),
          initialIndex: this.activeIndex
        });
        this.resizeObserver = new ResizeObserver(() => this.carousel?.resize());
        this.resizeObserver.observe(this.querySelector('.shop-by-room__media'));
      }
      select(index, animate = true) {
        if (!this.panels.length) return;
        const nextIndex = (index + this.panels.length) % this.panels.length;
        const changed = nextIndex !== this.activeIndex;
        if (animate && !changed) return;
        const instant = !animate;
        const image = this.panels[nextIndex].querySelector('img');
        if (animate && image) {
          image.loading = 'eager';
          image.decode().catch(() => {});
        }
        this.activeIndex = nextIndex;
        this.panels.forEach((panel, i) => {
          const selected = i === this.activeIndex;
          panel.hidden = false;
          panel.classList.toggle('is-active', selected);
          panel.inert = !selected;
          panel.setAttribute('aria-hidden', String(!selected));
        });
        this.controls.forEach((control) => {
          const selected = Number(control.dataset.roomIndex) === this.activeIndex;
          if (control.classList.contains('shop-by-room__room')) control.setAttribute('aria-current', String(selected));
          else control.setAttribute('aria-pressed', String(selected));
        });
        if (this.carousel) {
          this.carousel.select(this.activeIndex, false, instant);
        } else {
          this.track.style.transform = `translateX(-${this.activeIndex * 100}%)`;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.imageObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.carousel?.destroy();
        this.carousel = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
